<script>
    export let header;
    
    export let address = {
        name: "",
        address_1: "",
        address_2: "",
        city: "",
        state: "",
        zip: ""
    }
</script>

<main>
    <div class="flex flex-col md:flex-row w-3/4 md:border-b border-t border-gray-400 h-auto mx-auto justify-center md:mb-6 text-md">
        <div class="md:w-1/2 md:pt-10 pb-1 text-center">
            <div class="pt-4 md:pt-10 md:mt-10 text-2xl md:text-3xl">
                {header} Address
            </div>
            <div class="text-sm">
                Only US addresses are supported.
            </div>
        </div>
        <div class="md:w-1/2">
            <form class="w-full md:border-l border-gray-400 p-4 text-left text-black">
                <div>
                    <label for="name" class="block mb">
                        Full Name
                    </label>
                    <input bind:value={address.name} class="w-full p-2 border rounded placeholder-gray-500 outline-none focus:border-purple-900" type="text" placeholder="Full Name" />
                </div>
                <div class="my-2">
                    <label for="address_1" class="block mb">
                        Street Address Line 1
                    </label>
                    <input bind:value={address.address_1} class="w-full p-2 border rounded placeholder-gray-500 outline-none focus:border-purple-900" type="text" placeholder="Address Line 1" />
                </div>
                <div class="my-2">
                    <label for="address_2" class="block mb">
                        Street Address Line 2
                    </label>
                    <input bind:value={address.address_2} class="w-full p-2 border rounded placeholder-gray-500 outline-none focus:border-purple-900" type="text" placeholder="Address Line 2" />
                </div>
                <div class="flex flex-row my-2 justify-between">
                    <div class="thirtyone">
                        <label for="city" class="block mb">
                            City
                        </label>
                        <input bind:value={address.city} class="w-full p-2 border rounded placeholder-gray-500 outline-none focus:border-purple-900" type="text" placeholder="City" />
                    </div>
                    <div class="thirtyone">
                        <label for="state" class="block mb">
                            State
                        </label>
                        <input bind:value={address.state} class="w-full p-2 border rounded placeholder-gray-500 outline-none focus:border-purple-900" type="text" placeholder="State" />
                    </div>
                    <div class="thirtyone">
                        <label for="zipcode" class="block mb">
                            Zip
                        </label>
                        <input bind:value={address.zip} class="w-full p-2 border rounded placeholder-gray-500 outline-none focus:border-purple-900" type="text" placeholder="Zipcode" />
                    </div>
                </div>
            </form>
        </div>
    </div>
</main>

<style>
    .thirtyone {
        width: 31%;
    }
</style>